<template>
  <div class="resource-icon-sm">
    <i class="iconfont" :class="['icon-doc-' + type]"></i>
  </div>
</template>

<script>
export default {
  name: "icon-type",
  props: {
    //类型，可以取以下值：pdf, word, ppt,xls,audio,video,image,compress,excel,others
    type: {
      type: String,
      default: "others",
      validator: function (value) {
        // 这个值必须匹配下列字符串中的一个
        let types = [
          "pdf",
          "word",
          "ppt",
          "xls",
          "audio",
          "video",
          "image",
          "compress",
          "excel",
          "folder",
          "others",
        ];
        let passed = types.indexOf(value) > -1;
        if (passed) {
          return true;
        } else {
          throw new Error("传入的资料类型必须是以下几种：" + types);
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.resource-icon-sm {
  width: 25px;
  height: 25px;
  border: 1px solid #e6e6e6;
  border-radius: 2px;
  text-align: center;
  line-height: 25px;
  display: inline-block;
  vertical-align: middle;
}
.icon-doc-word {
  color: #1c99fe;
}
.icon-doc-pdf {
  color: #e03f3e;
}
.icon-doc-ppt {
  color: #fd7532;
}
.icon-doc-xls {
  color: #6eb451;
}
.icon-doc-audio {
  color: #d56ca6;
}
.icon-doc-video {
  color: #0cb8b2;
}
.icon-doc-image {
  color: #d77575;
}
.icon-doc-compress {
  color: #12bcf8;
}
.icon-doc-excel {
  color: #6eb451;
}
.icon-doc-others {
  color: #a6a6a6;
}
.icon-doc-folder {
  color: #faca29;
}
</style>
